import { DataForm, Stack, Title, Toggle } from "@introist/react-foundation/v2";
import { Block } from "components/atoms";
import { StepEditorAccordion } from "modules/workflows/routes/WorkflowEditor/StepEditorAccordion";
import { prefixForm } from "utils/FormUtils";
import styled from "styled-components";

const Setting = styled(Stack).attrs({ justifyContent: "space-between", alignItems: "center" })`
  > :last-child {
    flex-shrink: 0;
  }
`;

interface EmailSettingsProps {
  form: DataForm<any>;
  stepDataPath: string;
}

export const EmailSettings = ({ form, stepDataPath }: EmailSettingsProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  return (
    <Block compact blended>
      <StepEditorAccordion title="Settings" defaultOpen={false}>
        <Setting>
          <Title>Track email opens</Title>
          <Toggle
            checked={prefixedForm.get("trackEmail") ?? false}
            onChange={prefixedForm.set("trackEmail")}
          />
        </Setting>
      </StepEditorAccordion>
    </Block>
  );
};
